const ONLINE_INVESTMENTS = 40000;
const OFFLINE_INVESTMENTS = 60000;
const TRADEMARK_INVESTMENTS = 20000;

const ONLINE_OPERATIONAL_COSTS = 40000;
const OFFLINE_OPERATIONAL_COSTS = 100000;
const TRADEMARK_OPERATIONAL_COSTS = 40000;

export function retailInvestments(type, stores = 1) {
    if(type == 1) {
        return ONLINE_INVESTMENTS;
    }
    else if (type == 2) {
        return OFFLINE_INVESTMENTS * stores;
    }
    else if (type == 3) {
        return TRADEMARK_INVESTMENTS * stores;
    }
    else {
        throw new Error(`undefined channel type: ${type}`);
    }
}

export function operationalCosts(type, stores = 1) {
    if (type == 1) {
        return ONLINE_OPERATIONAL_COSTS;
    }
    else if (type == 2) {
        return OFFLINE_OPERATIONAL_COSTS * stores;
    }
    else if (type == 3) {
        return TRADEMARK_OPERATIONAL_COSTS * stores;
    }
    else {
        throw new Error(`undefined channel type: ${type}`);
    } 
}

export function getCoverage(type) {
    let coverage = 0;
    switch (type) {
      case 1:
        coverage = 160000;
        break;
      case 2:
        coverage = 80000;
        break;
      case 3:
        coverage = 30000;
        break;
      case 4:
        coverage = 20000;
        break;
      case 5:
        coverage = 20000;
        break;
      case 7:
        coverage = 120000;
        break;
      case 8:
        coverage = 40000;
        break;
    }
    return coverage;
}